import { IPolGeneralData } from '../models/processes.models';

/** OK visual del resultado general POL: deben cumplirse scoring y similitud global. */
export function isPolGeneralResultOk(general: IPolGeneralData | undefined): boolean {
	const scoring = general?.scoring;
	const conf = general?.conf;
	if (!scoring || !conf) return false;

	const passesScoring = scoring.result > (conf.minScoring ?? 7);
	const passesSimilarity = scoring.similarityPercentage >= (conf.minTotalSimilarityPercenteage ?? 0);

	return passesScoring && passesSimilarity;
}

/**
 * Selfies visibles en admin para POL (NIF-822).
 * Activa (`mode === 'auto'`): sin cambio de UI — hasta 2 (como el preview histórico).
 * Estática: solo la oficial (con ≥3 URLs en orden DESC del back → índice 1; si no → índice 0).
 */
export function polSelfiesForAdminPreview(
	selfie: string[] | undefined,
	mode: string | undefined,
): string[] {
	if (!selfie?.length) {
		return [];
	}
	if (mode === 'auto') {
		return selfie.slice(0, 2);
	}
	return [selfie.length >= 3 ? selfie[1] : selfie[0]];
}
